const getters = {
  vendorCategories: (state) => state.vendorCategories,
};

export default getters;
